import { loggedInUserActions } from "../loggedInUser";
import { getUserFromCookie } from "@/utils/auth";

/**
 * Gets the user data from the JWT in jwt cookie
 * If the JWT is not present, it returns null.
 * If the JWT is present, it fetches the user data from the server
 * @param {*} ctx Next's context object
 * @param {*} store Redux store
 * @returns
 */
const getUserData = async (ctx, store) => {
  // This only works on the server side as ctx is provided by Next.js
  const { user, session } = await getUserFromCookie(ctx);
  if (user) {
    store.dispatch(loggedInUserActions.SET_USER(user));
    store.dispatch(loggedInUserActions.SET_SESSION({ token: session }));
    return user;
  }
  return null;
};

const setUserData = (dispatch) => (user, token) => {
  dispatch(loggedInUserActions.SET_USER(user));
  dispatch(loggedInUserActions.SET_SESSION({ token }));
};

const loggedInUserHelpers = {
  getUserData,
  setUserData,
};

export default loggedInUserHelpers;
